var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _vm.ready
        ? _c(
            "w-row",
            { style: { maxHeight: "100%" }, attrs: { grow: "" } },
            [
              _c("app-folder-list", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$route.params.folderId || _vm.$wf.isMdUp,
                    expression: "!$route.params.folderId || $wf.isMdUp",
                  },
                ],
                attrs: { state: _vm.state },
              }),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "8", xl: "9" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fast-fade", mode: "out-in" } },
                    [
                      _vm.state.openedTask
                        ? _c("app-task-info", { attrs: { state: _vm.state } })
                        : _vm.state.openedFolder
                        ? _c("app-task-list", {
                            key: _vm.state.openedFolder.FolderID,
                            attrs: { state: _vm.state },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }